module.exports = __webpack_public_path__ + "img/whatsapp.9b1db846.svg";